import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FieldValidator } from './field-validator'
import * as moment from 'moment'
import { isMMDDYYYY } from './is-mmddyyyy'

@Component({
    selector: 'ValidatedDateTextField',
    templateUrl: './html-templates/validated-date-text-field.component.html'
})
export class ValidatedDateTextField {
    @Input() label = ''
    @Input() id = ''
    @Input() date: Date
    @Input() validationLabel: string
    @Input() disabled = false
    @Input() validators: FieldValidator<string>[]
    @Output() onDateChange: EventEmitter<Date | string> = new EventEmitter<Date | string>()

    dateToString(date: Date): string {
        if (!date) {
            return ''
        }

        return moment(date).format('MM/DD/YYYY')
    }

    getId() {
        return this.id
    }

    updateDate(newDate: string) {
        if (!newDate) {
            this.date = new Date()
            this.onDateChange.emit(undefined)
        } else if (!isMMDDYYYY(newDate)) {
            this.onDateChange.emit(newDate)
        } else {
            let date = moment(newDate, 'MM/DD/YYYY').toDate()

            this.date = date
            this.onDateChange.emit(date)
        }
    }
}
